import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomQuizCreator from '../components/CustomQuizCreator';
import MyCustomQuizzes from '../components/MyCustomQuizzes';

const CustomQuizPage = () => {
  const [showCreator, setShowCreator] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [quizCount, setQuizCount] = useState(0);
  const navigate = useNavigate();

  const handleQuizCreated = (quiz) => {
    // Refresh the custom quizzes list
    setRefreshKey(prev => prev + 1);
    setShowCreator(false);

    // Optionally navigate to the new quiz
    const takeQuiz = window.confirm(
      'Tạo bài tập tùy chỉnh thành công! Bạn có muốn làm bài ngay bây giờ không?'
    );
    if (takeQuiz) {
      navigate(`/quiz/${quiz._id}`);
    }
  };

  const handleCountChange = (count) => {
    setQuizCount(count);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Luyện Tập Bài Tập Tùy Chỉnh</h1>
          <p className="text-gray-600">
            Tạo bài tập cá nhân hóa bằng cách trộn câu hỏi từ nhiều bài tập khác nhau
          </p>
        </div>

        {/* Quota Display */}
        <div className={`mb-6 p-4 rounded-lg border-2 ${
          quizCount >= 10
            ? 'bg-red-50 border-red-300'
            : quizCount >= 8
            ? 'bg-yellow-50 border-yellow-300'
            : 'bg-blue-50 border-blue-300'
        }`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <svg
                className={`w-6 h-6 mr-3 ${
                  quizCount >= 10 ? 'text-red-600' : quizCount >= 8 ? 'text-yellow-600' : 'text-blue-600'
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <div>
                <p className={`font-semibold ${
                  quizCount >= 10 ? 'text-red-900' : quizCount >= 8 ? 'text-yellow-900' : 'text-blue-900'
                }`}>
                  Bài Tập Tùy Chỉnh: {quizCount} / 10
                </p>
                <p className={`text-sm ${
                  quizCount >= 10 ? 'text-red-700' : quizCount >= 8 ? 'text-yellow-700' : 'text-blue-700'
                }`}>
                  {quizCount >= 10
                    ? 'Đã đạt giới hạn. Vui lòng xóa bài tập cũ để tạo bài mới.'
                    : quizCount >= 8
                    ? 'Gần đạt giới hạn. Bạn có thể tạo thêm ' + (10 - quizCount) + ' bài tập.'
                    : 'Bạn có thể tạo tối đa 10 bài tập tùy chỉnh.'}
                </p>
              </div>
            </div>
            <div className={`text-3xl font-bold ${
              quizCount >= 10 ? 'text-red-600' : quizCount >= 8 ? 'text-yellow-600' : 'text-blue-600'
            }`}>
              {quizCount >= 10 ? '🚫' : quizCount >= 8 ? '⚠️' : '✅'}
            </div>
          </div>
        </div>

        {/* Toggle Creator Button */}
        {!showCreator && (
          <div className="mb-6">
            <button
              onClick={() => setShowCreator(true)}
              disabled={quizCount >= 10}
              className={`inline-flex items-center px-6 py-3 text-white font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all shadow-lg ${
                quizCount >= 10
                  ? 'bg-gray-400 cursor-not-allowed opacity-60'
                  : 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 hover:shadow-xl'
              }`}
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              {quizCount >= 10 ? 'Đã đạt giới hạn tạo bài tập' : 'Tạo Bài Tập Tùy Chỉnh Mới'}
            </button>
          </div>
        )}

        {/* Custom Quiz Creator */}
        {showCreator && (
          <div className="mb-8">
            <CustomQuizCreator
              onQuizCreated={handleQuizCreated}
              onClose={() => setShowCreator(false)}
            />
          </div>
        )}

        {/* My Custom Quizzes List */}
        <div>
          <MyCustomQuizzes
            refreshTrigger={refreshKey}
            onCountChange={handleCountChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomQuizPage;
